module.exports = __webpack_public_path__ + "img/map1.3cc8f210.jpg";